import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is Zapier, and how does it work with Exact Mails?",
      answer: "Zapier is an automation tool that connects Exact Mails with thousands of other apps, enabling seamless email discovery and workflow automation without coding.",
    },
    {
      question: "How do I set up Exact Mails with Zapier?",
      answer: "To connect Exact Mails with Zapier, sign in to Zapier, create a new Zap, select Exact Mails as a trigger app, and follow the setup instructions to integrate it with your workflow.",
    },
    {
      question: "What actions can I automate using Exact Mails and Zapier?",
      answer: "You can automate email discovery, save results to Google Sheets, send notifications to Slack, trigger CRM updates, and more using Zapier’s workflow automation.",
    },
    {
      question: "Do I need coding skills to use Exact Mails with Zapier?",
      answer: "No, Zapier allows you to automate workflows between Exact Mails and other apps with a simple, no-code interface.",
    },
    {
      question: "Can I use Zapier to automatically verify emails found by Exact Mails?",
      answer: "Yes, you can set up a Zap to automatically verify emails discovered by Exact Mails and store only the verified ones in your database or CRM.",
    },
    {
      question: "What are some popular integrations with Exact Mails via Zapier?",
      answer: "Popular integrations include Google Sheets, HubSpot, Salesforce, Slack, Mailchimp, and more to streamline email discovery and outreach processes.",
    },
    {
      question: "Is there a limit to how many Zaps I can create with Exact Mails?",
      answer: "Zapier's free and paid plans determine the number of Zaps you can create. Check Zapier’s pricing for details on automation limits.",
    },
    {
      question: "How frequently does Zapier sync data with Exact Mails?",
      answer: "Sync frequency depends on your Zapier plan. Free users get updates every 15 minutes, while premium users can get updates every minute.",
    },
    {
      question: "Can I use Exact Mails and Zapier for bulk email searches?",
      answer: "Yes, you can automate bulk email searches with Zapier by connecting Exact Mails to Google Sheets or your CRM for large-scale email discovery.",
    },
    {
      question: "Where can I get support for Exact Mails and Zapier integration?",
      answer: "For assistance, visit the Exact Mails help center or Zapier’s support documentation, or contact our support team for direct guidance.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-2xl mx-auto mt-14 mb-24">
      <h2 className="text-2xl lg:text-3xl text-gray-700 font-semibold text-center mb-6 lg:mb-10">
        Frequently Asked Questions
      </h2>
      {faqs.map((faq, index) => (
        <div key={index} className="border-b border-gray-200">
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full flex justify-between items-center py-4 text-left text-lg font-medium text-gray-800"
          >
            {faq.question}
            {openIndex === index ? (
              <FaChevronUp className="text-gray-600" />
            ) : (
              <FaChevronDown className="text-gray-600" />
            )}
          </button>
          {openIndex === index && (
            <div className="px-4 py-4 text-gray-600 bg-[#F0F0F0] border-t border-gray-200 text-sm">
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FaqSection;